import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
  input: {
    padding: theme.spacing(),
  },
});

const Search = withStyles(styles)(({ classes, ...props }) => (
  <TextField
    type="text"
    placeholder="Search"
    variant="outlined"
    margin="dense"
    InputProps={{
      classes: {
        input: classes.input,
      },
      endAdornment: (
        <InputAdornment position="end">
          <IconButton aria-label="Toggle password visibility">
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      ),
    }}
    {...props}
  />
));

export default Search;
